export default __webpack_public_path__ + "8275f45e74bcfab7db3fdd01c1a7b02b.jpg";